// eslint-disable-next-line import/no-internal-modules
import { FilterOptionItem } from '@insided/deprecated-control/overview/filters/FilterOption'
import { Permission, Role, RoleList } from './interfaces'

const mapUserRoles = (roles: Role[]) => roles.map(roleMapper)

const roleMapper = (role: Role) => ({
  id: role.id,
  name: role.label,
  value: role.id,
  isMain: role.isMain
})
const generateRolesSelectorOptionsGroup = (roles: Role[], groupTitle: FilterOptionItem): FilterOptionItem[] | [] =>
  roles.length ? [groupTitle, ...mapUserRoles(roles)] : []

export const getExistingRules = (selectorOptions: Role[], rules: Permission[]) =>
  selectorOptions.filter(({ name }) => rules.find(({ role }) => role === name)?.visibility)

export const generateRolesSelectorOptions = (roles: RoleList): FilterOptionItem[] => {
  const { mainRoles, customRoles } = roles

  const mainRolesTitle: FilterOptionItem = { id: 'main-role-title', name: 'title', value: 'PRIMARY USER ROLE' }
  const mainRolesGroup = generateRolesSelectorOptionsGroup(mainRoles, mainRolesTitle)

  const customRolesTitle: FilterOptionItem = { id: 'custom-role-title', name: 'title', value: 'CUSTOM USER ROLE' }
  const customRolesGroup = generateRolesSelectorOptionsGroup(customRoles, customRolesTitle)

  const separator: FilterOptionItem = { id: 'separator', name: 'separator', value: 'separator' }

  return [...mainRolesGroup, separator, ...customRolesGroup]
}

export const mapRolesToPermissions = (selectedRoles: Role[], roles: Role[]): Permission[] =>
  roles.map((role) => {
    const isSelected = selectedRoles.filter((selectedRole) => selectedRole.name === role.name).length > 0

    return { role: role.name, title: role.label, view: isSelected }
  })
